const RELOAD_KEY = 'signmeup:vite-preload-reload-at'
const RELOAD_WINDOW_MS = 15_000

/** What each browser says when a hashed chunk from a previous deploy no longer exists. */
const STALE_CHUNK_PATTERN =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/

export function isStaleChunkError(error: unknown): boolean {
  return error instanceof Error && STALE_CHUNK_PATTERN.test(error.message)
}

/**
 * Reloads once so the page picks up the current deploy's assets. A second failure inside the
 * window means the fresh assets are broken too, and reloading again would only loop.
 *
 * Pass the address the user was heading to when a navigation failed, so the reload lands there
 * rather than on the page they were leaving.
 */
export function reloadForStaleAssets(targetUrl?: string): boolean {
  const lastReloadAt = Number(window.sessionStorage.getItem(RELOAD_KEY) ?? 0)
  const now = Date.now()

  if (Number.isFinite(lastReloadAt) && now - lastReloadAt < RELOAD_WINDOW_MS) {
    return false
  }

  window.sessionStorage.setItem(RELOAD_KEY, String(now))
  if (targetUrl) {
    window.location.assign(targetUrl)
  } else {
    window.location.reload()
  }
  return true
}
